module.exports = __webpack_public_path__ + "static/media/shell-logo.0ff8fbce.png";